import axios from "axios";

const AUDIT_LOG_URL = "/admin/audit_log/";

/**
 * Fetches a paginated page of admin audit log entries (Super Admin only).
 * Empty/blank filter values are omitted from the query.
 * @param {Object} filters - { page, per_page, admin_id, target_user_id, action, start_date, end_date }
 * @param {Object} [options]
 * @param {AbortSignal} [options.signal] - Optional cancel signal
 * @returns {Promise<Object>} { page, per_page, total, pages, items }
 */
async function fetchAuditLog(filters, { signal } = {}) {
    const params = {};
    Object.entries(filters || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") params[key] = value;
    });
    const { data } = await axios.get(AUDIT_LOG_URL, { params, signal });
    return data;
}

export { fetchAuditLog };
